import { getLocalDateString, parseLocalDateString } from './dateUtils';

export const PAYROLL_CUTOVER_DATE = '2026-08-13';

const toDate = (value) => {
  if (value instanceof Date) {
    return value;
  }
  return parseLocalDateString(value);
};

export function getWithholdingRate(therapist, periodStartDate) {
  const start = toDate(periodStartDate);
  const cutover = parseLocalDateString(PAYROLL_CUTOVER_DATE);
  const isNewRules = start >= cutover;

  if (therapist.sworn_declaration) {
    return isNewRules ? 0 : 0.05;
  }

  return 0.10;
}

export function getWithholdingRateForSession(therapist, sessionDate) {
  const session = toDate(sessionDate);
  const cutover = parseLocalDateString(PAYROLL_CUTOVER_DATE);

  if (therapist.sworn_declaration) {
    return session >= cutover ? 0 : 0.05;
  }

  return 0.10;
}

export function shouldShowBIR2307(therapist, biMonthlyPeriod, selectedMonth, selectedYear) {
  if (biMonthlyPeriod !== 'second') {
    return false;
  }

  if (!therapist.sworn_declaration) {
    return true;
  }

  return selectedMonth === 7 && selectedYear === 2026;
}

export function isFinalReceiptTherapist2307(selectedMonth, selectedYear) {
  return selectedMonth === 7 && selectedYear === 2026;
}

export function getBIR2307DateRange(selectedMonth, selectedYear, therapist) {
  let startMonth = selectedMonth - 1;
  let startYear = selectedYear;

  if (startMonth < 0) {
    startMonth = 11;
    startYear = selectedYear - 1;
  }

  const startDate = new Date(startYear, startMonth, 27);
  let endDate = new Date(selectedYear, selectedMonth, 26);

  if (
    therapist.sworn_declaration &&
    selectedMonth === 7 &&
    selectedYear === 2026
  ) {
    endDate = new Date(selectedYear, selectedMonth, 12);
  }

  return { startDate, endDate };
}

export function getBIR2307WithholdingRate(therapist) {
  if (therapist.sworn_declaration) {
    return 0.05;
  }

  return 0.10;
}

export function calculateWithholdingTax(therapist, totalAmount, periodStartDate) {
  const taxRate = getWithholdingRate(therapist, periodStartDate);
  return {
    taxRate,
    withholdingTax: totalAmount * taxRate,
    shouldApplyTax: taxRate > 0,
  };
}

export function calculateSessionWithholdingTax(therapist, sessionDate, sessionAmount) {
  const taxRate = getWithholdingRateForSession(therapist, sessionDate);
  return sessionAmount * taxRate;
}

export function getWithholdingTaxStatusMessage(therapist, taxRate) {
  if (taxRate === 0 && therapist.sworn_declaration) {
    return {
      text: 'Issues client receipts — no withholding tax',
      color: 'green.500',
    };
  }

  if (taxRate === 0.05) {
    return {
      text: 'Issues client receipts (5% withholding tax applied — pre-Aug 13 period)',
      color: 'blue.500',
    };
  }

  return {
    text: 'Center-issued receipts (10% withholding tax applied)',
    color: 'orange.500',
  };
}

export function formatWithholdingBadge(taxRate) {
  if (taxRate === 0) {
    return null;
  }

  return `${(taxRate * 100).toFixed(0)}% WHT`;
}

export function formatToLocalDate(date) {
  return getLocalDateString(date);
}
